// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Restaumatic$dForm$dTestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $PaymentMethod = tag => ({tag});
const cardAmountIsSymbol = {reflectSymbol: () => "cardAmount"};
const cashAmountIsSymbol = {reflectSymbol: () => "cashAmount"};
const SplitPaymentInfoIsSymbol = {reflectSymbol: () => "SplitPaymentInfo"};
const CashIsSymbol = {reflectSymbol: () => "Cash"};
const OnlineIsSymbol = {reflectSymbol: () => "Online"};
const CardIsSymbol = {reflectSymbol: () => "Card"};
const PrepaidIsSymbol = {reflectSymbol: () => "Prepaid"};
const OfflineIsSymbol = {reflectSymbol: () => "Offline"};
const CashAndCardIsSymbol = {reflectSymbol: () => "CashAndCard"};
const BankTransferIsSymbol = {reflectSymbol: () => "BankTransfer"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum))(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor))))));
const encodeWithOptionsOther = {encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode};
const decodeWithOptionsOther = {decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode};
const SplitPaymentInfo = x => x;
const Cash = /* #__PURE__ */ $PaymentMethod("Cash");
const Online = /* #__PURE__ */ $PaymentMethod("Online");
const Card = /* #__PURE__ */ $PaymentMethod("Card");
const Prepaid = /* #__PURE__ */ $PaymentMethod("Prepaid");
const Offline = /* #__PURE__ */ $PaymentMethod("Offline");
const CashAndCard = /* #__PURE__ */ $PaymentMethod("CashAndCard");
const BankTransfer = /* #__PURE__ */ $PaymentMethod("BankTransfer");
const toFillFormTypeSplitPaymen = {fillFormDataType: v => "unknown"};
const newtypeSplitPaymentInfo_ = {Coercible0: () => {}};
const hasFieldSplitPaymentInfo = dictHasField => dictHasField;
const eqSplitPaymentInfo = {eq: x => y => x.cardAmount === y.cardAmount && x.cashAmount === y.cashAmount};
const eqPaymentMethod = {
  eq: x => y => {
    if (x.tag === "Cash") { return y.tag === "Cash"; }
    if (x.tag === "Online") { return y.tag === "Online"; }
    if (x.tag === "Card") { return y.tag === "Card"; }
    if (x.tag === "Prepaid") { return y.tag === "Prepaid"; }
    if (x.tag === "Offline") { return y.tag === "Offline"; }
    if (x.tag === "CashAndCard") { return y.tag === "CashAndCard"; }
    if (x.tag === "BankTransfer") { return y.tag === "BankTransfer"; }
    return false;
  }
};
const ordPaymentMethod = {
  compare: x => y => {
    if (x.tag === "Cash") {
      if (y.tag === "Cash") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Cash") { return Data$dOrdering.GT; }
    if (x.tag === "Online") {
      if (y.tag === "Online") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Online") { return Data$dOrdering.GT; }
    if (x.tag === "Card") {
      if (y.tag === "Card") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Card") { return Data$dOrdering.GT; }
    if (x.tag === "Prepaid") {
      if (y.tag === "Prepaid") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Prepaid") { return Data$dOrdering.GT; }
    if (x.tag === "Offline") {
      if (y.tag === "Offline") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Offline") { return Data$dOrdering.GT; }
    if (x.tag === "CashAndCard") {
      if (y.tag === "CashAndCard") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "CashAndCard") { return Data$dOrdering.GT; }
    if (x.tag === "BankTransfer") {
      if (y.tag === "BankTransfer") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqPaymentMethod
};
const genericSplitPaymentInfo = {to: x => x, from: x => x};
const showSplitPaymentInfo = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ cardAmount: " + Data$dMoney$dRounded.toString(v.cardAmount) + ", cashAmount: " + Data$dMoney$dRounded.toString(v.cashAmount) + " " + "}"]
    })(SplitPaymentInfoIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeSplitPaymentInfo = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble$dGeneric.genericUnsafeDecodeTagged(genericSplitPaymentInfo)(Unscramble$dGeneric.genericDecodeSumConstruct(SplitPaymentInfoIsSymbol)({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons(cardAmountIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons(cashAmountIsSymbol)(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordNil)).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.defaultOptions)
  }
))();
const genericPaymentMethod = {
  to: x => {
    if (x.tag === "Inl") { return Cash; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return Online; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return Card; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return Prepaid; }
          if (x._1._1._1.tag === "Inr") {
            if (x._1._1._1._1.tag === "Inl") { return Offline; }
            if (x._1._1._1._1.tag === "Inr") {
              if (x._1._1._1._1._1.tag === "Inl") { return CashAndCard; }
              if (x._1._1._1._1._1.tag === "Inr") { return BankTransfer; }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Cash") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Online") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Card") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "Prepaid") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "Offline") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
      );
    }
    if (x.tag === "CashAndCard") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    if (x.tag === "BankTransfer") {
      return Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum(
          "Inr",
          Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
        )
      );
    }
    $runtime.fail();
  }
};
const showPaymentMethod = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CashIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OnlineIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CardIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(PrepaidIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(OfflineIsSymbol);
    const $5 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(CashAndCardIsSymbol);
    const $6 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(BankTransferIsSymbol);
    return x => {
      const $7 = genericPaymentMethod.from(x);
      if ($7.tag === "Inl") { return $0["genericShow'"]($7._1); }
      if ($7.tag === "Inr") {
        if ($7._1.tag === "Inl") { return $1["genericShow'"]($7._1._1); }
        if ($7._1.tag === "Inr") {
          if ($7._1._1.tag === "Inl") { return $2["genericShow'"]($7._1._1._1); }
          if ($7._1._1.tag === "Inr") {
            if ($7._1._1._1.tag === "Inl") { return $3["genericShow'"]($7._1._1._1._1); }
            if ($7._1._1._1.tag === "Inr") {
              if ($7._1._1._1._1.tag === "Inl") { return $4["genericShow'"]($7._1._1._1._1._1); }
              if ($7._1._1._1._1.tag === "Inr") {
                if ($7._1._1._1._1._1.tag === "Inl") { return $5["genericShow'"]($7._1._1._1._1._1._1); }
                if ($7._1._1._1._1._1.tag === "Inr") { return $6["genericShow'"]($7._1._1._1._1._1._1); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodePaymentMethod = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericPaymentMethod)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Cash"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Online"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Card"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Prepaid"), Data$dGeneric$dRep.NoArguments)]})(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Offline"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("CashAndCard"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("BankTransfer"), Data$dGeneric$dRep.NoArguments)]})))))))(Unscramble$dEnum.defaultEnumOptions)
};
const ufromJSONKeyPaymentMethod = /* #__PURE__ */ (() => ({fromJSONKey: Unscramble.$FromJSONKeyFunction("FromJSONKeyValue", unscrambleDecodePaymentMethod.unsafeDecode)}))();
const boundedPaymentMethod = /* #__PURE__ */ (() => (
  {
    top: genericPaymentMethod.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum(
        "Inr",
        Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))))
      )
    )),
    bottom: genericPaymentMethod.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordPaymentMethod
  }
))();
const enumPaymentMethod = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericPaymentMethod)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericPaymentMethod)(genericEnumSum1),
  Ord0: () => ordPaymentMethod
};
const boundedEnumPaymentMethod = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericPaymentMethod)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericPaymentMethod.from(x)),
    Bounded0: () => boundedPaymentMethod,
    Enum1: () => enumPaymentMethod
  }
))();
const toFillFormTypePaymentMeth = {
  fillFormDataType: /* #__PURE__ */ Restaumatic$dForm$dTestHelpers.defaultEnumFillFormDataType(genericPaymentMethod)(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Cash\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"Online\""})(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Card\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"Prepaid\""})(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({
    gdefaultEnumFillFormDataType: v => "\"Offline\""
  })(/* #__PURE__ */ Restaumatic$dForm$dTestHelpers.gEnumToFillFormTypeSum({gdefaultEnumFillFormDataType: v => "\"CashAndCard\""})({
    gdefaultEnumFillFormDataType: v => "\"BankTransfer\""
  })))))))
};
const encodingOptsSplitPaymentInfo = {...Foreign$dGeneric$dClass.defaultOptions, unwrapSingleConstructors: true, unwrapSingleRecordArguments: true};
const encodeSplitPaymentInfo = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor(SplitPaymentInfoIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(cashAmountIsSymbol)(encodeWithOptionsOther))(cardAmountIsSymbol)(encodeWithOptionsOther);
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts({...encodingOptsSplitPaymentInfo, unwrapSingleConstructors: false})
  }
))();
const encodePaymentMethod = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericPaymentMethod)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("Cash"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("Online"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("Card"); }
          if (v1._1._1.tag === "Inr") {
            if (v1._1._1._1.tag === "Inl") { return v.constructorTagTransform("Prepaid"); }
            if (v1._1._1._1.tag === "Inr") {
              if (v1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("Offline"); }
              if (v1._1._1._1._1.tag === "Inr") {
                if (v1._1._1._1._1._1.tag === "Inl") { return v.constructorTagTransform("CashAndCard"); }
                if (v1._1._1._1._1._1.tag === "Inr") { return v.constructorTagTransform("BankTransfer"); }
                $runtime.fail();
              }
              $runtime.fail();
            }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const decodeSplitPaymentInfo = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericSplitPaymentInfo)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SplitPaymentInfoIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(cashAmountIsSymbol)(decodeWithOptionsOther)())(cardAmountIsSymbol)(decodeWithOptionsOther)())))(Foreign$dGeneric$dClass.genericCountArgsArgument))({
    ...encodingOptsSplitPaymentInfo,
    unwrapSingleConstructors: false
  })
};
const decodePaymentMethod = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericPaymentMethod)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(CashIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(OnlineIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(CardIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(PrepaidIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(OfflineIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(CashAndCardIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(BankTransferIsSymbol))))))))
};
const asJSONKeyPaymentMethod = /* #__PURE__ */ (() => (
  {asJSONKey: Data$dMap$dSerialized.$AsJSONKeyFunction("AsJSONKeyValue", encodePaymentMethod.encode, decodePaymentMethod.decode)}
))();
export {
  $PaymentMethod,
  BankTransfer,
  BankTransferIsSymbol,
  Card,
  CardIsSymbol,
  Cash,
  CashAndCard,
  CashAndCardIsSymbol,
  CashIsSymbol,
  Offline,
  OfflineIsSymbol,
  Online,
  OnlineIsSymbol,
  Prepaid,
  PrepaidIsSymbol,
  SplitPaymentInfo,
  SplitPaymentInfoIsSymbol,
  asJSONKeyPaymentMethod,
  boundedEnumPaymentMethod,
  boundedPaymentMethod,
  cardAmountIsSymbol,
  cashAmountIsSymbol,
  decodePaymentMethod,
  decodeSplitPaymentInfo,
  decodeWithOptionsOther,
  encodePaymentMethod,
  encodeSplitPaymentInfo,
  encodeWithOptionsOther,
  encodingOptsSplitPaymentInfo,
  enumPaymentMethod,
  eqPaymentMethod,
  eqSplitPaymentInfo,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericPaymentMethod,
  genericSplitPaymentInfo,
  genericTopConstructor,
  hasFieldSplitPaymentInfo,
  newtypeSplitPaymentInfo_,
  ordPaymentMethod,
  showPaymentMethod,
  showSplitPaymentInfo,
  toFillFormTypePaymentMeth,
  toFillFormTypeSplitPaymen,
  ufromJSONKeyPaymentMethod,
  unscrambleDecodePaymentMethod,
  unscrambleDecodeSplitPaymentInfo
};
